import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseService } from 'src/app/services/course.service';
import { ErrorService } from 'src/app/services/error.service';
import { catchError, switchMap, take } from 'rxjs/operators';
import { Course } from 'src/app/models/course.model';
import { Bank } from 'src/app/models/bank.model';
import { AuthService } from 'src/app/services/auth.service';

import { ToastrService } from 'ngx-toastr';
import { from, Subject } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { getLocalTranslate, Translate } from 'src/app/helpers/global-functions'

import { NgForm } from '@angular/forms';
import { UploadService } from 'src/app/services/upload.service';
import { inject } from '@angular/core/testing';
import { Coupon } from 'src/app/models/coupon.model';

@Component({
  selector: 'app-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css']
})
export class CheckoutComponent implements OnInit {

  home: string = 'Home'
  coursesText: string = 'English Courses'
  checkout: string = 'Checkout'
  yourOrder: string = 'Your Order'
  choosePaymentMethod: string = 'Choose your payment method'
  transferMoney: string = 'Transfer Money'
  privacyTitle: string = 'Privacy'
  privacyDesc: string = ''
  enterTID: string = 'Please Enter TID...'
  transferRemark: string = ''
  submit: string = 'Submit'
  back: string = 'Back'
  next: string = 'Next'
  scanToPay: string = 'Scan to pay'
  screenShotImage: string = ''
  banks: Bank[] = []

  selectedBank: Bank = new Bank();

  public showSpinner: boolean;

  isLeftVisible = true;
  nextButtonTitle: string;
  disableNext: boolean;
  couponCode: string;
  coupon:Coupon;


  course: Course = new Course();

  constructor(
    private route: ActivatedRoute,
    private courseService: CourseService,
    private errorService: ErrorService,
    private toastr: ToastrService,
    private router: Router,
    private firestore: AngularFirestore,
    private uploadService: UploadService
  ) { }

  ngOnInit(): void {
    //this.nextButtonTitle = 'Next';
    this.disableNext = true;
    this.getCourse();
    this.needTranslate()
    this.courseService.getPaymentMethods().subscribe(result => {
      this.banks = result
    })
    console.log(document.body.clientWidth)
  }

  needTranslate() {
    this.home = getLocalTranslate('home', this.home)
    this.coursesText = getLocalTranslate('courses', this.coursesText)
    this.checkout = getLocalTranslate('checkout', this.checkout)
    this.yourOrder = getLocalTranslate('your-order', this.yourOrder)
    this.choosePaymentMethod = getLocalTranslate('choose-your-payment-method', this.choosePaymentMethod)
    this.transferMoney = getLocalTranslate('transfer-money', this.transferMoney)
    this.privacyTitle = getLocalTranslate('privacy-title', this.privacyTitle)
    this.privacyDesc = getLocalTranslate('privacy-description', this.privacyDesc)
    this.enterTID = getLocalTranslate('enter-tid', this.enterTID)
    this.transferRemark = getLocalTranslate('transfer-remark', this.transferRemark)
    this.submit = getLocalTranslate('submit', this.submit)
    this.back = getLocalTranslate('back', this.back)
    this.next = getLocalTranslate('next', this.next)
    this.nextButtonTitle = this.next;
    this.scanToPay = getLocalTranslate('scan-to-pay', this.scanToPay)
  }

  onSubmit(it: NgForm) {
    console.log(it.value);  // { first: '', last: '' }
    console.log(it.valid);  // false
  }

  getCourse() {
    let id = this.route.snapshot.params['courseId'];
    console.log(id);
    const id$ = new Subject<string>()
    const queryObservable = id$.pipe(
      switchMap(id =>
        this.firestore.collection('courses').doc(id).get()
      )

    );
    // subscribe to changes
    queryObservable.subscribe(queriedItem => {
      var course: Course = new Course()
      course.id = queriedItem.id
      Object.assign(course, queriedItem.data())
      this.course = course
    });

    // trigger the query
    id$.next(id)
  }

  onChoosePaymentMethod(bank) {
    this.selectedBank = bank
    this.disableNext = false
  }

  currentState = 'initial';

  changeState() {
    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
  }

  onNext(tid: string) {
    console.log(this.isLeftVisible)
    if (this.isLeftVisible) {
      // Next
      this.nextButtonTitle = this.submit;
      this.isLeftVisible = !this.isLeftVisible;
    } else {

      if (tid == '') {
        this.toastr.error('Please enter TID.');
        return;
      }
      if (this.screenShotImage == '') {
        this.toastr.error('Please upload screenshot.');
        return;
      }
      // var result = confirm("Are you sure to purchase this course?");
      // if (!result) {
      //   return;
      // }

      // Submit
      const course = {
        id: this.course.id,
        nameEn: this.course.nameEn,
        nameKh: this.course.nameKh,
        length: this.course.length,
        price: this.course.price,
        imageUrl: this.course.image.fileUrl,
        teacher: this.course.teacher,
        youtubeId: this.course.youtubeId
      }

      const bank = {
        id: this.selectedBank.id,
        nameEn: this.selectedBank.nameEn,
        nameKh: this.selectedBank.nameKh,
        accountName: this.selectedBank.accountName,
        accountNo: this.selectedBank.accountNo
      }
      this.showSpinner = true;
      this.courseService.checkOutCourse(course, bank, tid, this.screenShotImage,this.coupon)
        .pipe(
          catchError(this.errorService.handle)
        )
        .subscribe(
          result => {
            this.showSpinner = false;
            this.router.navigate(['my-account/dashboard']);
            this.toastr.success("Checkout Successfully");
          },
          error => {
            this.showSpinner = false;
            this.toastr.error("Checkout Failed");
          }
        )
    }
  }

  onBack() {
    this.nextButtonTitle = this.next;
    this.isLeftVisible = !this.isLeftVisible;

    if (this.isMobile()) {
      const paymentDiv = document.getElementById('payment-div') as HTMLElement;
      window.scrollTo({
        top: paymentDiv.offsetTop,
        behavior: "smooth"
      });
    }
  }

  setClasses(tid: string) {
    var condition = this.disableNext
    if (!this.isLeftVisible) {
      condition = (tid == "");
    }

    let classes = {
      'app-btn': true,
      'float-right': true,
      'disabled-button': condition
    }
    return classes;
  }

  setClassesLabel(){

    const condition = this.coupon;

    let classes = {
      'subtotal-amount': true,
      // 'float-right': true,
      'line-throught': condition
    }
    return classes;
 
  }

  setClassesInput(){
    const condition = this.coupon;
    let classes = {
      'form-control': true,
      'disabled': condition
    }
    return classes;
 
  }


  translate(textEn: string, textKh: string): string {
    return Translate(textEn, textKh)
  }

  onChooseFile(file) {
    this.onUpload(file)
  }

  async onUpload(file) {
    const randomId = Date.now();
    const uploadPath = "logos/" + randomId + ".png";
    this.showSpinner = true;
    const downloadURL = await this.uploadService.upload(uploadPath, file).then(function (result) {
      return result.ref.getDownloadURL().then(function (downloadURL) {
        return downloadURL;
      })
    })
    this.showSpinner = false;
    if (downloadURL) {
      this.toastr.success("Uploadeded image Successfully")
      this.screenShotImage = downloadURL
    } else {
      this.toastr.error("Upload image failed");
    }
  }

  isMobile() {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
  }


  onApplyCouponCode() {
    const code = this.couponCode;
    if (!code) {
      this.toastr.error('Please enter Coupon Code.');
      return;
    }

    this.showSpinner = true;
    this.courseService.checkCoupon(code)
      .pipe(
        catchError(this.errorService.handle)
      )
      .subscribe(
        result => {

          
          this.showSpinner = false;
          if (!result.data.item) {
            // No result
            this.toastr.error(result.data);
            return;
          }

          const coupon = result.data.item;
         

          if (!this.checkCanApplyCodeDate(coupon.startDate) || (coupon.appliesNumber <= 0)){
            this.toastr.error("Invalid Coupon Code.");
            return;
          }

          this.coupon = coupon; 

          this.toastr.success("Discount coupon has been applied");
        },
        error => {
          this.showSpinner = false;
          this.toastr.error("Oops, Something went wrong!");
        }
      )

  }

  checkCanApplyCodeDate(startDate){
    const now = new Date();
    const nowMilisecond = now.getTime();
    const condition = nowMilisecond >= startDate;
    console.log(condition);
    return condition;
  }

  getDiscountPrice(): Number{
    const showPrice = this.course.getShowPrice();
     if (this.coupon.discountType === 1){
            // Percentage
            const discount = ((showPrice * this.coupon.discountPrice)/100);
            return Math.round((showPrice - discount) * 100) / 100;
        }else{
            // USD
            return  Math.round((showPrice - this.coupon.discountPrice) * 100) / 100;
        }

  }
  

  onRemoveCoupon(){
    this.coupon = null;
    this.couponCode = '';
  }



}
